module.exports = __webpack_public_path__ + "static/media/banner_s_07.fa9b8e30.jpg";